export const DISCOUNT_TYPES = [
    { value: 'percentage', label: 'Percentage (%)' },
    { value: 'fixed_amount', label: 'Fixed Amount ($)' },
] as const;

export const MERCHANT_COUPON_NOTIFICATION_MESSAGES = {
    CREATE_SUCCESS: 'Coupon created successfully',
    CREATE_ERROR: 'Failed to create coupon',
    UPDATE_SUCCESS: 'Coupon updated successfully',
    UPDATE_ERROR: 'Failed to update coupon',
    VALIDATION_ERROR: 'Please fill in all required fields',
    INVALID_DATE_RANGE: 'End date must be after start date',
    INVALID_DISCOUNT_VALUE: 'Discount value must be greater than 0',
    INVALID_QUANTITY: 'Total quantity must be greater than 0',
} as const;
